import './App.css';
import Header from './components/Header'
// import Test from './components/Test'

function App() {  
  return (
    <div className="root">
      <Header></Header>
      {/* <Test></Test> */}
    </div>
  );
}



export default App;
